// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { createLinkIconStyles } from "@rc/App/SharedStyles/sharedStyles";
import { css } from "styled-components";

defaultShippingAddressStyles.headingGridItem = {
    width: 12,
    css: css`
        align-items: center;
        justify-content: space-between;
    `,
};


defaultShippingAddressStyles.editLink = {
    ...createLinkIconStyles(
        "EditSmallHover",
        {
            icon: {
                iconProps: {
                    size: 9,
                },
            },
        },
        false,
    ),
};

defaultShippingAddressStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};